import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/layout/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import CentenaryPage from "./pages/CentenaryPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import PlanningPage from "./pages/PlanningPage";
import VolunteeringPage from "./pages/VolunteeringPage";
import CompetitionPage from "./pages/CompetitionPage";
import { NewsPage, NewsArticlePage } from "./pages/NewsPage";
import AboutPage from "./pages/AboutPage";
import DonatePage from "./pages/DonatePage";
import InitiativesPage from "./pages/InitiativesPage";
import CountyPage from "./pages/CountyPage";
import ResourcesPage from "./pages/ResourcesPage";
import EventsPage from "./pages/EventsPage";
import GovernancePage from "./pages/GovernancePage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import AdminNewsPage from "./pages/AdminNewsPage"; // New admin page
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import ProtectedAdminRoute from "./pages/admin/ProtectedAdminRoute";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/centenary" element={<CentenaryPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:id" element={<ProjectDetailPage />} />
        <Route path="/initiatives" element={<InitiativesPage />} />
        <Route path="/county/:county" element={<CountyPage />} />
        <Route path="/planning" element={<PlanningPage />} />
        <Route path="/volunteering" element={<VolunteeringPage />} />
        <Route path="/competition" element={<CompetitionPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:id" element={<NewsArticlePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/governance" element={<GovernancePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin/news"
          element={
            <ProtectedAdminRoute>
              <AdminNewsPage />
            </ProtectedAdminRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
